import React from 'react';
import { XIcon } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function FailedSolutions() {
  const failures = [{
    title: 'Dietas restrictivas',
    desc: 'Aumentan el cortisol, lo que ordena a tu cuerpo retener más líquidos por supervivencia.'
  }, {
    title: "Batidos 'detox' verdes",
    desc: 'Suelen tener fibras insolubles que irritan un intestino ya estresado, causando más gas.'
  }, {
    title: 'Exceso de ejercicio cardiovascular',
    desc: 'Inflama tus tejidos en lugar de repararlos.'
  }, {
    title: 'Contar calorías',
    desc: "No sirve de nada si tus hormonas están enviando la señal de 'almacenar emergencia'."
  }];
  return <section className="bg-beige py-20 px-4" data-id="element-33">
      <div className="max-w-4xl mx-auto" data-id="element-34">
        <FadeIn data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-36">
            ¿Por qué lo que has intentado{' '}
            <span className="text-muted-red italic" data-id="element-37">no funciona</span>?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-38">
            {failures.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-39">
                <div className="bg-white p-6 rounded-2xl shadow-sm h-full flex items-start space-x-4 border border-cream" data-id="element-40">
                  <div className="bg-red-50 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-41">
                    <XIcon className="w-6 h-6 text-muted-red" data-id="element-42" />
                  </div>
                  <div data-id="element-43">
                    <h3 className="font-bold text-brown-dark mb-2 text-lg" data-id="element-44">
                      {item.title}
                    </h3>
                    <p className="text-brown-body" data-id="element-45">{item.desc}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}